import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { MapCableDataPoint } from '@/server/MakeSenseApp-backend'
import { PropType } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Points',
  props: {
  sensorReadings: {
    type: Array as PropType<MapCableDataPoint[]>,
    required: true
  },
  isVisible: {
    type: Boolean,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_ol_geom_point = _resolveComponent("ol-geom-point")!
  const _component_ol_style_fill = _resolveComponent("ol-style-fill")!
  const _component_ol_style_circle = _resolveComponent("ol-style-circle")!
  const _component_ol_style = _resolveComponent("ol-style")!
  const _component_ol_feature = _resolveComponent("ol-feature")!
  const _component_ol_source_vector = _resolveComponent("ol-source-vector")!
  const _component_ol_vector_layer = _resolveComponent("ol-vector-layer")!

  return (_openBlock(), _createBlock(_component_ol_vector_layer, {
    zIndex: "500",
    visible: __props.isVisible
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ol_source_vector, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sensorReadings, (reading, index) => {
            return (_openBlock(), _createBlock(_component_ol_feature, { key: index }, {
              default: _withCtx(() => [
                _createVNode(_component_ol_geom_point, {
                  coordinates: [reading.coordinate?.easting, reading.coordinate?.northing]
                }, null, 8, ["coordinates"]),
                _createVNode(_component_ol_style, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ol_style_circle, { radius: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ol_style_fill, { color: "yellow" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})